import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-41744cd2"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "店铺名称", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "类型", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "所属社区", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "地址", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "门牌号", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "社会信用代码", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "营业执照", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "到期时间", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "店铺状态", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更新时间", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "创建时间", -1));
const _hoisted_12 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_DialogCustomView = _resolveComponent("DialogCustomView");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_row, {
    class: "tableContainer"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, {
      class: "tableRow"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 3,
        class: "tableItemName"
      }, {
        default: _withCtx(() => [_hoisted_1]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 5,
        class: "tableItemValue"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.shop.shopName), 1)]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 3,
        class: "tableItemName"
      }, {
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 5,
        class: "tableItemValue"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.shop.shopTypeName), 1)]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 3,
        class: "tableItemName"
      }, {
        default: _withCtx(() => [_hoisted_3]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 5,
        class: "tableItemValue"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.shop.communityName), 1)]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      class: "tableRow"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 3,
        class: "tableItemName"
      }, {
        default: _withCtx(() => [_hoisted_4]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 13,
        class: "tableItemValue"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.shop.address), 1)]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 3,
        class: "tableItemName"
      }, {
        default: _withCtx(() => [_hoisted_5]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 5,
        class: "tableItemValue"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.shop.streetName) + "/" + _toDisplayString($props.shop.doorCode), 1)]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      class: "tableRow"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 3,
        class: "tableItemName"
      }, {
        default: _withCtx(() => [_hoisted_6]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 5,
        class: "tableItemValue"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.shop.licenseCode), 1)]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 3,
        class: "tableItemName"
      }, {
        default: _withCtx(() => [_hoisted_7]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 5,
        class: "tableItemValue"
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          style: {
            "color": "#1388ff",
            "cursor": "pointer"
          },
          onClick: _cache[0] || (_cache[0] = $event => $data.preview = true)
        }, "查看图片")]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 3,
        class: "tableItemName"
      }, {
        default: _withCtx(() => [_hoisted_8]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 5,
        class: "tableItemValue"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.shop.licenseExpireTime), 1)]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      class: "tableRow"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 3,
        class: "tableItemName"
      }, {
        default: _withCtx(() => [_hoisted_9]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 5,
        class: "tableItemValue"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.shop.state == 'RUNNING' ? '正常经营' : '搬迁/停业'), 1)]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 3,
        class: "tableItemName"
      }, {
        default: _withCtx(() => [_hoisted_10]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 5,
        class: "tableItemValue"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.shop.updatedTime), 1)]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 3,
        class: "tableItemName"
      }, {
        default: _withCtx(() => [_hoisted_11]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 5,
        class: "tableItemValue"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.shop.createdTime), 1)]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_DialogCustomView, {
    width: "40%",
    title: "查看图片",
    "visible-control": $data.preview,
    onClose: _cache[1] || (_cache[1] = $event => $data.preview = false)
  }, {
    default: _withCtx(() => [_createElementVNode("img", {
      src: $props.shop.licenseImage,
      style: {
        "width": "100%"
      }
    }, null, 8, _hoisted_12)]),
    _: 1
  }, 8, ["visible-control"])], 64);
}